export default "__VITE_ASSET__2bYh0nTR__"